/*
 * Author: Chao.Wang
 * File Created: Monday, 25-01-06 04:15 pm
 * Last Modified: Wednesday, 25-03-26 11:35 am, by Harper Yan
 */

import { useCallback, useEffect } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { showDialog, showSnackbar } from '@ucard/ds/message';
import type { Agreement } from '@/@types/agreement';
import useOpenApi from '@/hooks/useOpenApi';
import { getAgreementConfirmInfo } from '@/services/account/service';
import { useAgreement } from '@/stores/useAgreementStore';
import { useUserInfo } from '@/stores/useUserStore';
import type { ConfirmAgreementDialogProps } from './ConfirmAgreementDialog';
import ConfirmAgreementDialog from './ConfirmAgreementDialog';
const useTermsConditions = () => {
  const {
    isOpenApiMode
  } = useOpenApi();
  const {
    isLogin
  } = useUserInfo();
  const {
    agreementInfo,
    signAgreement,
    updateAgreement,
    getAgreementInfo
  } = useAgreement();
  const {
    t
  } = useTranslation('common');
  const router = useRouter();
  useEffect(() => {
    getAgreementInfo(['TERMS_CONDITIONS', 'PRIVACY_POLICY']);
  }, [getAgreementInfo]);

  /**
   * 确认协议
   * @param closeDialogFn 确认协议后关闭dialog
   */
  const handleConfirmTC = useCallback(async (closeDialogFn: () => void) => {
    await signAgreement(['TERMS_CONDITIONS']);
    closeDialogFn();
    showSnackbar({
      message: t('terms-conditions-update.successTip')
    });
  }, [signAgreement, t]);
  const getConfirmInfo = useCallback(async () => {
    const {
      data: confirmInfo
    } = await getAgreementConfirmInfo([{
      type: 'TERMS_CONDITIONS',
      version: agreementInfo.TERMS_CONDITIONS.version
    }]);
    if (!confirmInfo[0]?.confirmedResult) {
      const closeDialog = showDialog<ConfirmAgreementDialogProps>(ConfirmAgreementDialog, {
        showClose: false,
        agreementInfo: agreementInfo.TERMS_CONDITIONS as Agreement,
        onConfirm: () => {
          handleConfirmTC(closeDialog);
        },
        disableBackdropClose: true
      });
    } else {
      updateAgreement('TERMS_CONDITIONS', {
        confirmStatus: true
      });
    }
  }, [agreementInfo.TERMS_CONDITIONS, handleConfirmTC, updateAgreement]);
  useEffect(() => {
    if (router.pathname !== '/landing/home' && !isOpenApiMode && isLogin && agreementInfo.TERMS_CONDITIONS.version && !agreementInfo.TERMS_CONDITIONS.confirmStatus) {
      getConfirmInfo();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- ignore
  }, [isOpenApiMode, isLogin, agreementInfo.TERMS_CONDITIONS.version, agreementInfo.TERMS_CONDITIONS.confirmStatus, router.pathname]);
};
export default useTermsConditions;